<template>
  <div class="fixed menu-right m-right-menu-top">
    <div class="p-4">
      <img src="@/assets/images/menu/support_title.png" class="c-side-menu__title">
      <ul class="fixed menu-right m-right-menu-left w-64 mt-8 bg-white border rounded-2xl border-gray-300 shadow-md">
        <li class="mx-4 pt-4 pb-4 border-b-2"><a :href="base_url()" aria-current="page" class="c-side-menu__link nuxt-link-exact-active nuxt-link-active"><img src="@/assets/images/menu/pc-button-text-right-01.svg"></a></li>
        <li class="h-16 mx-4 pt-3 border-b-2"><a :href="base_url() + '/portal/topics'" class="c-side-menu__link"><img src="@/assets/images/menu/pc-button-text-right-02.svg"></a></li>
        <li class="h-16 mx-4 pt-3 border-b-2"><a :href="base_url() + '/portal/news'" class="c-side-menu__link"><img src="@/assets/images/menu/pc-button-text-right-03.svg"></a></li>
        <li class="mx-4 pt-4 mb-3"><a :href="base_url() + '/portal/faq'" class="c-side-menu__link"><img src="@/assets/images/menu/pc-button-text-right-04.svg"></a></li>
      </ul>
      <ul class="fixed menu-right m-right-menu-left w-64 mt-72 pt-4 pl-12">
        <li class="mt-4"><a :href="base_url() + '/portal/contact'" class="c-side-menu__subLink"><img src="@/assets/images/menu/pc-textlink-01.svg"></a></li>
        <li class="mt-4"><a :href="base_url() + '/portal/terms'" class="c-side-menu__subLink"><img src="@/assets/images/menu/pc-textlink-02.svg"></a></li>
        <li class="mt-4"><a :href="base_url() + '/portal/terms/cookie'" class="c-side-menu__subLink"><img src="@/assets/images/menu/pc-textlink-03.svg"></a></li>
        <li class="mt-4"><a href="https://www.jreast.co.jp/site/privacy.html" target="_blank" class="c-side-menu__subLink"><img src="@/assets/images/menu/pc-textlink-04.svg"></a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants";

export default {
  name: 'TheHeader',
  methods: {
    base_url: function () {
      return Constants.LINK_BASE_URL
    }
  }
}
</script>
